import React from "react";
import { Row, Col, Form, Button, Modal, Dropdown } from "react-bootstrap";
import {
  getContactsActions,
  deleteContactAction,
  editSetAsDefaultContactAction,
  getUserRolesAction,
  reActivateDeletedContactAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import AddContact from "./CreateContact";
import EditContact from "./EditContact";
import noRecord from "./../../assets/img/no-record.png";
import NoContact from "./../../assets/img/no-contact.jpg";
import PhoneNumber from "../Common/phoneNumber";
import DataTable from "react-data-table-component";
import Logo from "./../../assets/img/logo.png";
import { toastMessage } from "../Common/Common";
import * as code from "../../config/Constants";
import { TextField, IconButton } from "@material-ui/core";
import {
  CheckCircle,
  CheckCircleOutline,
  Restore,
  Delete,
  Edit,
  Search,
} from "@material-ui/icons";
import { InputAdornment } from "@material-ui/core";
import { color } from "highcharts";

const ContactsFilter = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search by name"
      value={filterText}
      onChange={onFilter}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      variant="standard"
    />
    <Button
      type="button"
      onClick={onClear}
      variant="primary"
      className="btn-blue btn-head ml-2"
    >
      Clear
    </Button>
  </>
);

const columns = [
  {
    name: "Name",
    selector: "firstname",
    sortable: true,
    ignoreRowClick: true,
  },
  {
    name: "Role",
    selector: "role",
    sortable: true,
  },
  {
    name: "Phone Number",
    selector: "mobileNumber",
    sortable: true,
  },
  {
    name: "Email",
    selector: "email",
    sortable: true,
    width: "25%",
  },
  {
    name: "Status",
    selector: "isDeletedVendor",
    sortable: true,
    width: "75px",
    right: true,
    center: true,
  },
  {
    name: "",
    selector: "color",
    sortable: true,
    width: "75px",
    right: true,
    center: true,
  },
  {
    name: "",
    selector: "edit",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
  {
    name: "",
    selector: "delete",
    right: true,
    ignoreRowClick: true,
    width: "75px",
  },
];

function Contacts({
  getContactsActions,
  getUserRolesAction,
  deleteContactAction,
  reActivateDeletedContactAction,
}) {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const [contacts, setContacts] = React.useState([]);
  const [showAddModal, setShowAddModal] = React.useState(false);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [contactData, setContactData] = React.useState({});
  const [showLoader, setShowLoader] = React.useState(false);

  React.useEffect(() => {
    setShowLoader(true);
    getAllContacts();
  }, []);

  function getAllContacts() {
    getContactsActions("Artist")
      .then((contactRes) => {
        getUserRolesAction();
        setContacts(contactRes.data);
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
      });

    return contacts;
  }

  function deleteContact(id) {
    deleteContactAction(id)
      .then((res) => {
        getAllContacts();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function showAddContactModal() {
    setShowAddModal(true);
  }

  function closeAddModal() {
    setShowAddModal(false);
    getAllContacts();
  }

  function editContact(id) {
    setShowEditModal(true);
    setContactData({
      id: id,
    });
  }

  function closeEditModal() {
    setShowEditModal(false);
    getAllContacts();
  }

  function reActivateUser(userId) {
    reActivateDeletedContactAction(userId)
      .then((response) => {
        getAllContacts();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  let rows = [];
  for (var i = 0; i < contacts.length; i++) {
    let contact = contacts[i];

    let contactObject = {
      id: contact.contactId,
      firstname: contact.firstname + " " + contact.lastname,
      role: contact.roles,
      mobileNumber: <PhoneNumber phoneNumber={contact.mobileNumber} />,
      email: contact.email,
      isDeletedVendor:
        contact.isDeletedVendor === false ? (
          <CheckCircle className="check" style={{ color: "green" }} />
        ) : (
          <CheckCircleOutline className="check-out" />
        ),
      delete:
        contact.isDeletedVendor === false ? (
          <IconButton
            onClick={() =>
              deleteContact(contact.contactId) &&
              !contact.isDeletedVendor === true
            }
          >
            <Delete />
          </IconButton>
        ) : (
          <IconButton
            onClick={() =>
              reActivateUser(contact.contactId) && !contact.isDeletedVendor
            }
          >
            <Restore />
          </IconButton>
        ),
      edit:
        contact.isDeletedVendor === false ? (
          <IconButton
            onClick={() =>
              editContact(contact.contactId) && !contact.isDeletedVendor
            }
          >
            <Edit />
          </IconButton>
        ) : (
          ""
        ),
      color: (
        <div
          className={"contact-color-btn"}
          style={{
            height: "20px",
            width: "20px",
            backgroundColor: contact.color,
          }}
        />
      ),
    };

    rows.push(contactObject);
  }
  const filteredContacts = rows.filter(
    (contact) =>
      (contact.role === "Artist" &&
        (contact.firstname &&
          contact.firstname
            .toLowerCase()
            .includes(filterText.toLowerCase()))) ||
      (contact.lastname &&
        contact.lastname.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <ContactsFilter
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  });

  return (
    <div>
      <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
        <Col xs="4">
          <h4 className="title-med mt-0 pt-1">Artists</h4>
        </Col>
        <Col align="right" className="contact-btn">
          <Button
            variant="primary"
            className="btn-blue btn-head"
            onClick={() => {
              // if (localStorage.getItem("isActive") === "false") {
              //     toastMessage(code.ERROR, "Your subscription is not active, Please activate to continue.");
              // } else {
              //     showAddContactModal()
              // }

              showAddContactModal();
            }}
          >
            Add Artist
          </Button>
        </Col>
      </Row>

      {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : rows.length === 0 ? (
        <div className="no-transaction">
          <div className="no-transaction-inner">
            <img src={Logo} className="no-transaction-content" alt="" />
            <h2 className="no-transaction-content">No artists found</h2>
            <hr />
            <Button
              className="text-uppercase btn-orange btn-orange-lg"
              onClick={() => {
                // if (localStorage.getItem("isActive") === "false") {
                //   toastMessage(
                //     code.ERROR,
                //     "Your subscription is not active, Please activate to continue."
                //   );
                // } else {
                //   showAddContactModal();
                // }

                showAddContactModal();
              }}
            >
              Add Artist
            </Button>
          </div>
        </div>
      ) : (
        <DataTable
          title="Artists"
          columns={columns}
          data={filteredContacts}
          pagination
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
        />
      )}

      <Modal
        show={showAddModal}
        onHide={() => closeAddModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Add Artist
          </Modal.Title>
        </Modal.Header>
        <AddContact onClose={() => closeAddModal()} contacts={contacts} />
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => closeEditModal()}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        className="modal-med"
        backdrop={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Edit Artist
          </Modal.Title>
        </Modal.Header>
        <EditContact
          contactData={contactData}
          contacts={contacts}
          onClose={() => closeEditModal()}
        />
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    getContactsActions,
    deleteContactAction,
    editSetAsDefaultContactAction,
    getUserRolesAction,
    reActivateDeletedContactAction,
  }
)(Contacts);
